import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from "../LeftSideMain.module.scss";
import ExitIcon from "../../../shared/icons/ExitIcon";
import MenuIcon from "../../../shared/icons/MenuIcon";


const LeftSideButtonClose = ({isExpand, toggleExpand}) => {
    const { t } = useTranslation();
    return (
        <button
            className={ styles["navigation-custom__label"]}
            aria-label={t('sidebar.buttons.menuAriaLabel')}
            onClick={toggleExpand}
        >
            {isExpand ? (
                <ExitIcon/>
            ) : (
                ''
            )}
        </button>

    );
};

export default LeftSideButtonClose;
